import { render, staticRenderFns } from "./AddCargoModal.vue?vue&type=template&id=24d518d6&scoped=true&"
import script from "./AddCargoModal.vue?vue&type=script&lang=js&"
export * from "./AddCargoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d518d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/forge/portmann.hmd.lv/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VCard,VFlex,VForm,VIcon,VLayout,VTextField})
